// ==================================================================
// ProductCategory.ts で扱うClass, Modelの共通部分をBaseとして定義する
// ==================================================================

export default class ProductCategoryBase {
  public nid: number;
  public type: string;
  public name: string;
  public alias: string;
  public linkTitle: string;
  public linkUrl: string;
  public parentNid: number;
  public categoryId: number;
  public subName: string;
  public imagePath: string;
  public imageAlt: string;

  constructor() {
    this.nid = 0
    this.type = ''
    this.name = ''
    this.alias = ''
    this.linkTitle = ''
    this.linkUrl = ''
    this.parentNid = 0
    this.categoryId = 0
    this.subName = ''
    this.imagePath = ''
    this.imageAlt = ''
  }
}

export interface ProductCategoryBaseModel {
  nid: number;
  type: string;
  name: string;
  alias: string;
  linkTitle: string;
  linkUrl: string;
  parentNid: number;
  categoryId: number;
  subName: string;
  imagePath: string;
  imageAlt: string;
}
